export default __webpack_public_path__ + "static/media/bila-sesit2.f04957d7.svg";